import { useEffect, useRef } from "react";

// Fires `onIntersect` whenever the returned ref's element scrolls into view, as long as
// `enabled` is true -- callers gate that on "more pages exist AND nothing is already
// loading" so this never double-fires mid-fetch or keeps firing past the last page.
export function useInfiniteScrollSentinel(onIntersect, enabled) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    const el = sentinelRef.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) onIntersect();
      },
      { rootMargin: "400px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [onIntersect, enabled]);

  return sentinelRef;
}
